import { Component, ChangeDetectionStrategy, input } from "@angular/core";
import { TranslateModule } from "@ngx-translate/core";
import { TeacherProfile } from "../../../api/models/teacher-profile";

@Component({
  selector: "app-teacher-contact-details",
  standalone: true,
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [TranslateModule],
  // display:contents so the address rows join the parent contact-details grid
  // (in app-profile-shell) and align with the other rows.
  host: { class: "contents" },
  template: `
    @if (profile().address) {
    <div class="text-mty-body/60">{{ "Address" | translate }}</div>
    <div class="text-mty-body break-words">
      {{ profile().address.street }} {{ profile().address.number }}
      {{ profile().address.numberSuffix }}<br />
      {{ profile().address.postalCode }}, {{ profile().address.city }}<br />
      {{ profile().address.country }}
    </div>
    }
  `,
})
export class TeacherContactDetailsComponent {
  profile = input.required<TeacherProfile>();
}
